import React from 'react';
const CircleLoader=(props)=>{
    return(
        <div className="dotLoaderBox">
        <span className="dot-loader" style={{backgroundColor:props.bgColor}}></span>
        <span className="dot-loader dot-loader--2" style={{backgroundColor:props.bgColor}}></span>
        <span className="dot-loader dot-loader--3" style={{backgroundColor:props.bgColor}}></span>
      </div>
    )
}
export default CircleLoader;